export const HOME_MODULAR_GRADIENT_BACKDROP_CLASS =
  'modular-home-gradient-backdrop'

export const STUDENT_APP_SCROLL_CONTAINER_ID = 'student-app-root'
export const STUDENT_APP_TOPBAR_HEIGHT = 72
export const STUDENT_APP_SIDEBAR_WIDTH = 72
export const STUDENT_APP_GRADIENT_BACKDROP_SCROLL_TIMELINE =
  '--student-app-gradient-backdrop-scroll'
const TOP_BAR_BLUR_MASK =
  'linear-gradient(180deg, #000 0%, #000 80%, transparent 100%)'

export const STUDENT_APP_GRADIENT_BACKDROP_TOP_BAR = {
  position: 'relative',
  '@keyframes studentAppGradientBackdropTopBarScrim': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  ':before': {
    background:
      'linear-gradient(180deg, #16181F 9.72%, rgba(22, 24, 31, 0.00) 93.75%)',
    content: '""',
    inset: 0,
    opacity: 0,
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: -1,
    '@supports (animation-timeline: scroll())': {
      animationName: 'studentAppGradientBackdropTopBarScrim',
      animationTimingFunction: 'linear',
      animationFillMode: 'both',
      animationTimeline: STUDENT_APP_GRADIENT_BACKDROP_SCROLL_TIMELINE,
      animationRange: `1px ${STUDENT_APP_TOPBAR_HEIGHT}px`,
    },
  },
  // Sits below the scrim so the blur samples the page content rather than the
  // scrim's own gradient, and stops short of the scroll container's scrollbar,
  // which the bar overlaps.
  ':after': {
    backdropFilter: 'blur(8px)',
    content: '""',
    inset: 0,
    maskImage: TOP_BAR_BLUR_MASK,
    WebkitMaskImage: TOP_BAR_BLUR_MASK,
    pointerEvents: 'none',
    position: 'absolute',
    right: 4,
    zIndex: -2,
  },
} as const
